import { render, staticRenderFns } from "./QuestionBankTopicImport.vue?vue&type=template&id=afcdabf6&scoped=true&"
import script from "./QuestionBankTopicImport.vue?vue&type=script&lang=js&"
export * from "./QuestionBankTopicImport.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBankTopicImport.vue?vue&type=style&index=0&id=afcdabf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcdabf6",
  null
  
)

export default component.exports